import { Minus, Plus } from 'phosphor-react'
import { useState } from 'react'

import { LineData } from '../../../../../components/LineData'
import { type MeetingExpertHistoryDomain } from '../../../../../types/domain/meeting-expert-history-domain'

type Props = {
  info: MeetingExpertHistoryDomain
}

export const HistoryDetailLine = ({ info }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const analysts = info?.task?.project?.analysts?.map((analyst) => analyst.fullName).join(', ')
  const convertedDate = new Date(info?.startAt).toLocaleDateString('pt-BR')
  const assets = info?.task?.project?.assets?.map((asset) => asset.fullName).join(', ')

  return (
    <div className="border-b-1 border-grey-500">
      <div className="flex flex-row items-center justify-between py-5">
        <div className="">
          <a className="pr-[14px] border-r-1 border-grey-200">{info?.task?.project?.name}</a>
          <a className="pl-[14px]">{convertedDate}</a>
        </div>

        <div className="cursor-pointer mr-3">
          {isOpen ? (
            <Minus
              size={18}
              onClick={() => {
                setIsOpen(false)
              }}
            />
          ) : (
            <Plus
              size={18}
              onClick={() => {
                setIsOpen(true)
              }}
            />
          )}
        </div>
      </div>
      <div
        className={`${
          isOpen ? 'max-h-80 mt-1 mb-6' : 'max-h-0 my-0'
        } transition-all duration-500 ease-in-out overflow-hidden`}
      >
        <LineData label={'Data'} text={convertedDate} />
        <LineData label={'Projeto'} text={info?.task?.project?.name} />
        <LineData label={'Analista'} text={analysts} />
        <LineData label={'Assets'} text={assets} />
      </div>
    </div>
  )
}
